<cmps-dialog>
    <cmps-dialog-header class="cmps-transcript-dialog--header">
        <div
            class="cmps-cdk-d-flex cmps-cdk-pb-0dot5"
            *ngIf="!_service.state?.pending?.reload"
        >
            <div class="cmps-cdk-flex-grow-1 cmps-cdk-mr-0dot5">
                <input
                    type="text"
                    class="cmps-transcript-dialog--title"
                    [placeholder]="
                        (_i18n._9996_TRANSCRIPTS | translate) +
                        ' ' +
                        _service.state?.transcript?.transcriptId?.toString()
                    "
                    [disabled]="true"
                    [ngModel]="_service.state?.transcript?.name"
                    [ngModelOptions]="{ updateOn: 'blur' }"
                    (ngModelChange)="_onTitleChange($event)"
                />
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n.__BACK | translate"
                    trigger="hover"
                    (click)="_onBackClick()"
                    *ngIf="
                        _service.state?.view === _View.NOTES &&
                        _service.state?.hasCoachAssist === true
                    "
                >
                    <cmps-icon svgIcon="arrow-left"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [disabled]="_service.state?.pending.updateTranscript"
                    [cmpsTooltipTrigger]="_i18n._10020_SAVE | translate"
                    trigger="hover"
                >
                    <cmps-icon svgIcon="content-save-outline"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        (!_dialogRef.expanded
                            ? _i18n._9977_EXPAND
                            : _i18n._9978_COLLAPSE
                        ) | translate
                    "
                    trigger="hover"
                    (click)="
                        !_dialogRef.expanded
                            ? _dialogRef.expand()
                            : _dialogRef.collapse()
                    "
                >
                    <cmps-icon
                        [svgIcon]="
                            !_dialogRef.expanded
                                ? 'arrow-expand'
                                : 'arrow-collapse'
                        "
                    ></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    trigger="hover"
                    (click)="_dialogRef.close()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-cdk-h-100p">
        <div class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-h-100p">
            <div
                class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-flex-grow-1"
                *ngIf="_service.state?.pending?.reload"
            >
                <cmps-wait-status></cmps-wait-status>
            </div>
            <ng-container *ngIf="!_service.state?.pending?.reload">
                <div
                    class="cmps-cdk-mb-0dot5"
                    *ngIf="_service.state?.transcript?.transcriptId != null"
                >
                    {{ _i18n._10058_CREATED_ON_ | translate }}
                    {{
                        _service.state?.transcript?.createdOn
                            | cmpsDate: 'EEEE, MMMM d, y, h:mm:ss a'
                    }}
                </div>
                <div class="cmps-cdk-flex-grow-1">
                    <cmps-transcript-dialog-landing
                        *ngIf="_service.state?.view === _View.LANDING"
                    ></cmps-transcript-dialog-landing>
                    <cmps-transcript-dialog-notes-page
                        *ngIf="_service.state?.view === _View.NOTES"
                    ></cmps-transcript-dialog-notes-page>
                </div>
            </ng-container>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
